import Vue from "vue";

export const store = Vue.observable({
  NITTO: "日東電工",
  NDCS: "日東電工ＣＳシステム",
  SHINKO: "日東シンコー",
  NITOMS: "ニトムズ"
});
